const publicPath = process.env.PUBLIC_PATH;
const batteryData = require('../../public/notificationAssets/battery/index.json');

export const data = [
  {
    id: 2,
    title: '动力电池相关信息公示',
    content: '',
    time: '2025-7-10',
    assets: batteryData.map(item => ({
      ...item,
      url: `${publicPath}/notificationAssets/battery/pack/${item.url}`
    }))
  },
  {
    id: 1,
    title: '小鹏汽车维修信息购买流程',
    content: `尊敬的用户，您好！<br/><br/>
    您可免费查看用户手册，如需查看维修手册、电路图等信息，请通过小鹏汽车APP扫下方二维码购买。如果您在使用过程中遇到问题，可以发送邮件至 <a href="mailto:sip@x-peng.cn">sip@x-peng.cn</a>，感谢支持！<br/><br/>
    <div style="width: 100%;display: flex;align-items: center;justify-content: center;"><img src="${publicPath}/notificationAssets/qrcode.png"/></div>
    <br/><br/>使用流程：<br/>
1.登录注册小鹏汽车维修资料平台：<a href="https://sip.xiaopeng.com" target="_blank">https://sip.xiaopeng.com</a>。<br/>
2.发送兑换码和注册账户ID、手机号，以及付款凭证截图附件到管理员邮箱：<a href="mailto:sip@x-peng.cn">sip@x-peng.cn</a><br/>
3.管理员依据验证码和订单信息开通账户查阅权限，并邮件反馈开通成功后即可正常查看。`,
    time: '2025-5-20',
    assets: []
  }
];

export const globalData = [
  // 原始文档：https://xiaopeng.feishu.cn/docx/TbhqdKma3oYm4wxoeOxcSFIvnGE
  {
    id: 3,
    title: 'Alcohol Interlock Installation Guide Release',
    content: `<p>To be compliance with the laws and regulation in many markets, XPENG vehicles come with a reserved alcohol interlock connector to facilitate the alcohol interlock installation when needed.</p>
<p>To find out how to properly install an alcohol interlock, you may find the installation guide based on the vehicle model in the attached document below.</p>
<br />
<p>Give us feedback by email: <a href="mailto:overseasserviceengineering@x-peng.cn">overseasserviceengineering@x-peng.cn</a>, or through the feedback option in the right lower corner.</p>`,
    time: '2026-2-25',
    assets: [
      {
        name: 'Alcohol Interlock Installation Guide - P7.pdf',
        type: 'pdf',
        url: `${publicPath}/notificationAssets/Alcohol-Interlock-Installation-Guide-Release/Alcohol-Interlock-Installation-Guide-P7.pdf`
      },
      {
        name: 'Alcohol Interlock Installation Guide - G6.pdf',
        type: 'pdf',
        url: `${publicPath}/notificationAssets/Alcohol-Interlock-Installation-Guide-Release/Alcohol-Interlock-Installation-Guide-G6.pdf`
      },
      {
        name: 'Alcohol Interlock Installation Guide - G9.pdf',
        type: 'pdf',
        url: `${publicPath}/notificationAssets/Alcohol-Interlock-Installation-Guide-Release/Alcohol-Interlock-Installation-Guide-G9.pdf`
      }
    ]
  },
  {
    id: 2,
    title: 'Public Beta Launch Announcement: SIP System Online Release',
    content: `<p>We are pleased to announce the official launch of the SIP System, which is now entering its public beta phase. Starting today, the system will be open for a one-month public testing period, during which all users are warmly invited to access, explore, and experience its features.</p>
<p>During this public beta, no fees will be charged on manuals reading. Our goal is to gather valuable user feedback, particularly suggestions for improving the system manual and the maintenance information platform. Your insights will help us further optimize both the user guide and the platform’s functionality.</p>
<p>Public Beta Access Steps:</p>
<ol>
<li>Register an account on the platform.</li>
<li>Send your registration details to [<a href="mailto:overseasserviceengineering@x-peng.cn">overseasserviceengineering@x-peng.cn</a>] to activate a one-month trial period.</li>
<li>After the account activated we will give you a feedback by email.</li>
<li>During the trial, please share your feedback by completing our user experience survey via this link: [<a target="_blank" href="https://xiaopeng.feishu.cn/share/base/form/shrcnOMQnaoEI7PVbSJVRRUrWfd">Survey Questionnaire of SIP</a>].</li>
<li>Participation in the activity is voluntary. Please note that content and features are still under refinement during the testing period. XPENG reserves the right to interpret terms and make improvements as needed.</li>
</ol>
<p>We sincerely appreciate your participation and support.  The trial activity ends on February 28th.</p>
<p>Together, we can build a more efficient and user-friendly platform.</p>
<p>Thank you for being part of this journey.</p>`,
    time: '2026-1-15',
    assets: []
  }
];
